import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from 'vue'
import { api, formatMoney } from "@/main";
import Card from "@/components/Card.vue";
import { ChartData, UIEnvelope } from "@/api";
import { Line as LineChart, Bar as BarChart } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, BarElement, CategoryScale, LinearScale, PointElement } from 'chart.js'
import TransactionTable from "@/hoamodules/financial/TransactionTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Envelope',
  props: ['envelopeId', 'envelopes', 'accounts', 'mySecurities', 'incomeSources', 'household', 'financialModule'],
  emits: ['breadcrumbs', 'menuItems'],
  setup(__props, { emit }) {

const props = __props

ChartJS.register(Title, Tooltip, Legend, LineElement, BarElement, CategoryScale, LinearScale, PointElement)




const envelope = ref<UIEnvelope>();
const initialStartDate = new Date(Date.now() - (new Date().getTimezoneOffset() * 60000));
initialStartDate.setDate(initialStartDate.getDate() - 365 * 1);
initialStartDate.setDate(1);
const searchStartDate = ref(initialStartDate.toISOString().split('T')[0])
const searchEndDate = ref()
const showStartDatePickerMenu = ref(false);
const showEndDatePickerMenu = ref(false);
const dailyChartData = ref<ChartData>();
const monthlyChartData = ref<ChartData>();
const uncategorizedTransactions = ref<any[]>([]);

function graphLabel(context) {
  let label = context.dataset.label || '';

  if (label) {
    label += ': ';
  }
  if (context.parsed.y !== null) {
    label += formatMoney(context.parsed.y);
  }
  return label;
}

function refreshValues() {
  if (!envelope.value)
    return;

  api.financial_transaction.getDailyValueByEnvelope(envelope.value.financialModuleId, [envelope.value.id], searchStartDate.value, searchEndDate.value).then((newChartData: ChartData) => {
    dailyChartData.value = newChartData;
  });
  api.financial_transaction.geMonthlySummaryBySourceByEnvelope(envelope.value.financialModuleId, [envelope.value.id], searchStartDate.value, searchEndDate.value).then((newChartData: ChartData) => {
    const incomeColors = [
      'rgba(0, 128, 0, 0.8)',
      'rgba(60, 179, 113, 0.8)',
      'rgba(173, 216, 230, 0.8)',
      'rgba(144, 238, 144, 0.8)',
      'rgba(50, 205, 50, 0.8)',
      'rgba(32, 178, 170, 0.8)',
      'rgba(102, 205, 170, 0.8)',
      'rgba(143, 188, 143, 0.8)'
    ];
    let incomeColorIndex = 0;
    newChartData.datasets.forEach(dataset => {
      if (dataset.label === 'Expense') {
        dataset.backgroundColor = 'rgba(220, 20, 60, 0.8)';
        dataset.label = 'Expense (Average $' + dataset.average + ')';
      } else {
        dataset.backgroundColor = incomeColors[incomeColorIndex++];
        if (incomeColorIndex > incomeColors.length - 1)
          incomeColorIndex = 0;
      }
    });
    monthlyChartData.value = newChartData;
  });

  uncategorizedTransactions.value = [];
  api.financial_transaction.getTransactions(props.financialModule.id, [], [props.envelopeId],
    searchStartDate.value, searchEndDate.value, '', 0, [], '').then(transactions => {
    transactions.forEach(newTransaction => {
      if (newTransaction.envelopes)
        newTransaction.newEnvelopes = JSON.parse(JSON.stringify(newTransaction.envelopes));
    });
    transactions.sort((a, b) => b.date.localeCompare(a.date));
    uncategorizedTransactions.value = transactions;
  });
}

watch(() => props.envelopes, (newEnvelopes) => {
  if (envelope.value && envelope.value.id !== props.envelopeId) {
    envelope.value = undefined;
  }

  if (!envelope.value && newEnvelopes && newEnvelopes.length > 0) {
    envelope.value = newEnvelopes.find((newEnvelope: UIEnvelope) => newEnvelope.id === props.envelopeId);

    if (envelope.value) {
      refreshValues();

      emit('menuItems', []);
      emit('breadcrumbs', [{
        text: envelope.value.name,
        icon: 'mdi-email',
        to: '/h/' + props.household.id + '/f/' + props.financialModule.id + '/e/' + props.envelopeId
      }]);
    }
  }
}, { deep: true, immediate: true });

return { __sfc: true,props, emit, envelope, initialStartDate, searchStartDate, searchEndDate, showStartDatePickerMenu, showEndDatePickerMenu, dailyChartData, monthlyChartData, uncategorizedTransactions, graphLabel, refreshValues, formatMoney, Card, LineChart, BarChart, TransactionTable }
}

})